import { Button, WarningMessage } from "../../../../widgets";
import { ButtonStyle, ControlSize } from "../../../../base/types";
import { FC, useRef, useState } from "react"

import { IDetectFaceProps } from "./IDetectFaceProps"
import { IVisionDetectResponse } from "./services/IVisionDetectResponse";
import Webcam from "react-webcam";
import clsx from "clsx";
import { useDetectMutation } from "./services/visionApi";

export const DetectFace: FC<IDetectFaceProps> = ({ className, children, personGroupId, personId, onDetected }) => {
    const errorMessage = 'No face detected. Please try again.'
    const webcamRef = useRef<Webcam>(null);
    const [detect, { isLoading }] = useDetectMutation()
    const [isIdentical, setIsIdentical] = useState<boolean>();
    const [error, setError] = useState<string>("");

    const onConfirm = () => {
        if (!webcamRef.current) {
            setError('Webcam is not ready. please try again later')
            return;
        }

        setIsIdentical(false);
        const imageSrc = webcamRef.current.getScreenshot();
        const base64 = (imageSrc) ? imageSrc.split(",")[1] : '';
        detectFace(base64)
            .then((data) => {
                if (!data.isIdentical)
                    setError('Sorry, your face does not match the profile picture.');

                setIsIdentical(data.isIdentical)
                onDetected && onDetected(data.isIdentical)
            })
            .catch((error) => setError(error));
    }

    const detectFace = (base64: string): Promise<IVisionDetectResponse> => {
        if (!base64 || !personGroupId || !personId)
            return Promise.reject(errorMessage);

        return detect({ content: base64, personGroupId, personId })
            .unwrap()
            .catch((error) => {
                const message = error?.data?.message || 'No face detected. Please try again.'
                return Promise.reject(message);
            })
    }

    if (!personGroupId || !personId) {
        return (
            <div className={clsx(className, "card border m-10")}>
                <div className="card-header min-h-5px ">
                    <div className="d-flex flex-column">
                        <h4 className="card-title">Face Detection</h4>
                    </div>
                </div>
                <WarningMessage className="card-body border-0 bg-transparent" message="Person Group Id and Person Id are required" />
            </div>
        )
    }

    if (isIdentical) {
        return <div className={className}>{children}</div>
    }

    return (
        <div className={clsx(className, "d-flex flex-column gap-2 align-items-center justify-content-center")}>
            <div className="position-relative w-100 mw-400px">
                <div className="d-flex flex-column position-absolute top-0 start-0 end-0 bg-dark bg-opacity-25 text-white p-2">
                    <p className="fs-8 fw-bold my-0">Face Detection</p>
                    <p className="fs-9 text-light my-0">Please look straight at the camera.</p>
                </div>

                <Webcam
                    ref={webcamRef}
                    audio={false}
                    screenshotFormat="image/jpeg"
                    className='w-100 h-100' />

                <div className="position-absolute top-0 end-0 z-2 p-2">
                    <Button
                        buttonSize={ControlSize.Small}
                        buttonStyle={ButtonStyle.Primary}
                        iconClassName="me-1"
                        icon="CheckCircleOutlined"
                        isLoading={isLoading}
                        disabled={isLoading}
                        onClick={onConfirm}
                    >
                        Confirm
                    </Button>
                </div>
                {(!isLoading && !!error) && <>
                    <div className="position-absolute bottom-0 start-0 end-0 bg-danger text-white fst-italic fs-8 bg-opacity-50 p-2 mb-1">
                        {error}
                    </div>
                </>}
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}

